import {
  isAtomCommandInterrupted,
  squashAtomCommandFailure,
} from "@afar-research/client-runtime/state/runtime";
import type { EnvironmentId } from "@afar-research/contracts";
import { useCallback } from "react";

import { stackedThreadToast, toastManager } from "../components/ui/toast";
import { hostEnvironment } from "../connection/hostEnvironment";
import { commandFailureMessage } from "../rpc/transportError";
import { useAtomCommand } from "../state/use-atom-command";

/** Retries an unreachable Environment now, reporting a failed attempt as a toast. */
export function useReconnectEnvironment() {
  const retryEnvironment = useAtomCommand(hostEnvironment.retryNow, { reportFailure: false });
  return useCallback(
    async (environmentId: EnvironmentId) => {
      const result = await retryEnvironment(environmentId);
      if (result._tag === "Failure" && !isAtomCommandInterrupted(result)) {
        toastManager.add(
          stackedThreadToast({
            type: "error",
            title: "Could not reconnect environment",
            description: commandFailureMessage(
              squashAtomCommandFailure(result),
              "Failed to reconnect.",
            ),
          }),
        );
      }
    },
    [retryEnvironment],
  );
}
